<template>
  <div>
    <PageTitle :route="$route">
    </PageTitle>

    <PageRowWrapper>
      <div class="col-sm-12">
        <MaintanceReasonForm v-if="maintancereason" :maintanceReason="maintancereason" />
      </div>
    </PageRowWrapper>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import PageTitle from '@/components/layout/PageTitle'
  import PageRowWrapper from '@/components/layout/PageRowWrapper'
  import MaintanceReasonForm from '@/components/settings/test-registers/maintanceReason/MaintanceReasonForm.vue'

  export default {
    name: 'MaintanceReason',
    components: {
      PageTitle,
      PageRowWrapper,
      MaintanceReasonForm
    },
    computed: {
      ...mapState({
        maintancereason: state => state.maintancereason.maintanceReasonById
      })
    },
    methods: {
      ...mapActions('maintancereason', ['fetchById'])
    },
    mounted () {
      this.fetchById(this.$route.params.id)
    }
  }
</script>
